import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import CustomBreadCrumb from "../../components/breadCrumb/breadCrumb";
import { ButtonMethodCustom } from "../../components/button/buttonOption";
import { setTitleHeader } from "../../store/use-title-header-store";
import { useReloadSocket } from "../../utils/hooks/useReloadSocket";
import useResponsive from "../../utils/hooks/useResponsive";
import Crypto from "./component/crypto";
import CryptoDeposits from "./component/crypto-deposits";
import CryptoWithdrawals from "./component/crypto-withdrawals";
import Fiat from "./component/fiat";
import RequestMoney from "./component/request-money";
import SendMoney from "./component/send-money";
import "./history.css";

const breadCrumb = [
  {
    name: "Portfolio",
    path: "/",
  },
  {
    name: "Transactions / History",
    path: "/history",
  },
];

const methodList = [
  // {
  //   name: "Send money",
  //   value: "send-money",
  // },
  // {
  //   name: "Request money",
  //   value: "request-money",
  // },
  // {
  //   name: "Crypto deposits",
  //   value: "crypto-deposits",
  // },
  // {
  //   name: "Crypto withdrawals",
  //   value: "crypto-withdrawals",
  // },
  {
    name: "Fiat",
    value: "fiat",
  },
  {
    name: "Crypto",
    value: "crypto",
  },
];

export const ThemedHistory: React.FC<any> = () => {
  const navigate = useNavigate();
  const socket = useReloadSocket();
  const { isTablet } = useResponsive();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tab = queryParams.get("tab");
  const orderId = queryParams.get("orderId");
  const type = queryParams.get("type");
  const [method, setMethod] = useState<any>(tab || "fiat");

  const handleChangeTab = (value: string) => {
    navigate(`/history?tab=${value}`);
    setMethod(value);
  };

  useEffect(() => {
    setTitleHeader("Transactions / History");
  }, []);

  useEffect(() => {
    if (!tab) return;
    setMethod(tab);
  }, [tab]);

  // useEffect(() => {
  //   socket.connect();
  //   return () => {
  //     socket.disconnect();
  //   };
  // }, [socket]);

  return (
    <div className="history-container">
      <CustomBreadCrumb breadCrumb={breadCrumb} showHome={true} />
      <div className={"frame-history"}>
        <div className={"frame-history-left"}>
          {methodList.map((item) => (
            <ButtonMethodCustom
              size={isTablet ? "small" : "medium"}
              key={item.value}
              text={item.name}
              isSelected={method === item.value}
              onClick={() => handleChangeTab(item.value)}
            />
          ))}
        </div>
        <div className={"frame-history-right"}>
          {/* {method === "send-money" && (
            <SendMoney orderId={orderId || ""} socket={socket} />
          )}
          {method === "request-money" && (
            <RequestMoney orderId={orderId || ""} socket={socket} />
          )}
          {method === "crypto-deposits" && (
            <CryptoDeposits orderId={orderId || ""} socket={socket} />
          )}
          {method === "crypto-withdrawals" && (
            <CryptoWithdrawals orderId={orderId || ""} socket={socket} />
          )} */}
          {method === "crypto" && (
            <Crypto orderId={orderId || ""} socket={socket} type={type || null} />
          )}
          {method === "fiat" && (
            <Fiat orderId={orderId || ""} socket={socket} type={type || null} />
          )}
        </div>
      </div>
    </div>
  );
};
